import { CancelInteracMoneyRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useCancelInteracMoneyRequest({ bearer }: { bearer?: string }) {
  const [fetching, setFetching] = useState(false);

  async function cancelInteracMoneyRequest(params: CancelInteracMoneyRequest) {
    try {
      setFetching(true);
      const res = await api.postCancelInteracMoneyRequest(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, cancelInteracMoneyRequest };
}
